import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
    picker: {
        border: `1px solid ${theme.palette.ddSelector.borderColor} !important`,
        '& input': {
            backgroundColor: theme.palette.input.background,
            color: theme.palette.input.color,
            '&[disabled]': {
                background: theme.palette.disabled
            },
            '&:not([disabled]):hover': {
                borderColor: theme.palette.ddSelector.borderColor,
                backgroundColor: theme.palette.hoverBackgroundColor
            }
        },
        '& .rc-picker-active-bar': {
            background: `${theme.palette.ddSelector.itemSelected} !important`
        }
    },
    withSuffixIcon: ({ withClearIcon }) => ({
        '&:hover:not(.rc-picker-disabled)': {
            '& .rc-picker-clear': {
                display: withClearIcon ? 'flex' : 'none !important'
            },
            '& .rc-picker-suffix': {
                display: withClearIcon ? 'none !important' : 'flex'
            }
        }
    }),
    dropdown: {
        '& button, & .rc-picker-header': {
            backgroundColor: `${theme.palette.ddSelector.itemSelected} !important`
        },
        '& .rc-picker-panel-layout, .rc-picker-presets': {
            backgroundColor: theme.palette.ddSelector.item
        },
        '& .rc-picker-panel': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.ddSelector.item
        },
        '& .rc-picker-time-panel-column': {
            ...theme.themedClasses.scrollbar
        },
        '& .rc-picker-time-panel-cell': {
            '&:hover': {
                backgroundColor: theme.palette.ddSelector.itemHover
            },
            '&.rc-picker-time-panel-cell-selected': {
                backgroundColor: theme.palette.ddSelector.itemSelected
            },
            '& .rc-picker-time-panel-cell-inner': {
                color: theme.palette.text.primary
            }
        },
        '& .rc-picker-cell-in-view': {
            color: theme.palette.text.primary
        },
        '& .rc-picker-cell-selected, .rc-picker-cell-range-end, .rc-picker-cell-range-start': {
            backgroundColor: theme.palette.ddSelector.itemSelected,
            color: 'white'
        },
        '& .rc-picker-cell-today > .rc-picker-cell-inner': {
            border: `1px solid ${theme.palette.ddSelector.itemSelected}`
        },
        '& .rc-picker-week-panel-row:hover .rc-picker-cell': {
            backgroundColor: theme.palette.ddSelector.itemHover
        },
        '& .rc-picker-week-panel-row-selected .rc-picker-cell': {
            backgroundColor: theme.palette.ddSelector.itemSelected
        },
        '& .rc-picker-now-btn': {
            color: theme.palette.ddSelector.itemSelected
        },
        '& .rc-picker-presets li': {
            color: theme.palette.ddSelector.itemSelected,
            border: `1px solid ${theme.palette.ddSelector.itemSelected}`,
            '&:hover': {
                color: theme.palette.ddSelector.itemHover,
                backgroundColor: theme.palette.ddSelector.itemSelected
            }
        }
    }
}));
